import { SortType } from '../../enums/sort-data-task/sort-type';
import { SortField } from '../../interfaces/sort-data-task/sort-field';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a SortData task.
 * Sorts flow records (SortRecords) or sorts items within an array field (SortArray).
 * For SortArray, fieldKey in each SortField points to the array itself; items are compared by primitive value.
 */
export class SortDataConfig extends DestinationTaskConfigBase {
	/** What to sort. SortRecords=0 (sort flow records array), SortArray=1 (sort items within an array field). @default SortType.SortRecords */
	sortType: SortType = SortType.SortRecords;
	/**
	 * Sort criteria applied left-to-right (primary → secondary). Each entry has:
	 * - fieldKey: path within processingData (SortRecords) or path to the array itself (SortArray).
	 * - sortDirection: Ascending=0, Descending=1.
	 * @default []
	 */
	sortField: SortField[] = [];

	constructor(init?: Partial<SortDataConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
